"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevelopmentCenter = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var DevelopmentCenter = (function (_super) {
    __extends(DevelopmentCenter, _super);
    function DevelopmentCenter() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.DEVELOPMENT_CENTER,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 11,
            metadata: {
                cardNumber: '014',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 1 Energy to draw a card.', function (eb) {
                        eb.energy(1).startAction.cards(1);
                    });
                }),
            },
        }) || this;
    }
    DevelopmentCenter.prototype.play = function () {
        return undefined;
    };
    DevelopmentCenter.prototype.canAct = function (player) {
        return player.energy > 0;
    };
    DevelopmentCenter.prototype.action = function (player) {
        player.energy--;
        player.drawCard();
        return undefined;
    };
    return DevelopmentCenter;
}(Card_1.Card));
exports.DevelopmentCenter = DevelopmentCenter;
